import { render, staticRenderFns } from "./RagioneriaView.vue?vue&type=template&id=20f18f3e&scoped=true&"
import script from "./RagioneriaView.vue?vue&type=script&lang=ts&"
export * from "./RagioneriaView.vue?vue&type=script&lang=ts&"
import style0 from "./RagioneriaView.vue?vue&type=style&index=0&id=20f18f3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f18f3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VFadeTransition,VMain,VRow})
